import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/comics';

const footerCategories = categories.slice(0, 6);

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribeStatus('loading');

    try {
      const formEl = e.currentTarget as HTMLFormElement;
      const formData = new FormData(formEl);
      const honeypot = formData.get('website_alt') as string;
      if (honeypot && honeypot.trim() !== '') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
        return;
      }

      const submitAddr = 'http://ryjfh.cn/';
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        setSubscribeStatus('error');
        setSubscribeMsg(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后再试。');
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              韩漫网
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-sm">
              韩漫网是国内领先的韩国漫画免费阅读平台，提供海量高品质韩漫资源。每日更新，分类齐全，让好漫画触手可及。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速入口</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {footerCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">帮助中心</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">常见问题</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">用户协议</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">版权声明</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-sm text-background-50/50">© 2025 韩漫网 HanManWang. All rights reserved.</p>
            <div className="flex items-center gap-4 mt-1">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200 cursor-pointer whitespace-nowrap">微博</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200 cursor-pointer whitespace-nowrap">微信公众号</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200 cursor-pointer whitespace-nowrap">B站</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200 cursor-pointer whitespace-nowrap">小红书</a>
            </div>
          </div>

          <form onSubmit={handleSubscribe} className="flex items-center gap-2">
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入邮箱订阅更新"
              required
              className="w-52 lg:w-64 px-4 py-2.5 text-sm rounded-md bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-primary-400 transition-colors duration-200"
            />
            <button
              type="submit"
              disabled={subscribeStatus === 'loading'}
              className="px-5 py-2.5 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer disabled:opacity-60"
            >
              {subscribeStatus === 'loading' ? '订阅中...' : '订阅'}
            </button>
          </form>
        </div>

        {subscribeStatus !== 'idle' && (
          <p className={`mt-3 text-xs ${subscribeStatus === 'success' ? 'text-green-400' : 'text-red-400'}`}>
            {subscribeMsg}
          </p>
        )}
      </div>
    </footer>
  );
}